function lengthToFractions(length) {
  return "1fr ".repeat(length)
}

//Adaptive grid size, to ensure no "empty" space
function setGridSize(size, max) {
  if(size > max) {
    const options = []
    for (let i = 1; i < max+1; i++) {
      options.push([i, size % i])
    }
    const values = options.map(option => option[1])
    const min_value = Math.min(...values)
    const filter = options.filter(x => x[1] === min_value)
    const keys = filter.map(option => option[0])
    const max_key = Math.max(...keys)
    return filter.filter(x=> x[0] === max_key)[0][0]
  }
  return size
}

export { lengthToFractions, setGridSize }